/* eslint-disable no-extra-parens */
/* eslint-disable react/display-name */
import React, { memo, useCallback } from 'react';

import { reduxConnect } from '../../../common';
import { translate } from '../../../common/translation/translate';

import { AirQualityRecommendations, IStoreState } from '../../common/interfaces/types';
import { numberOfAqiListItemsLoading } from '../constants';
import { AirQualityListItem } from './airQualityListItem';
import { AqiHealthAdvicesTopTriggerHeader } from './aqiHealthAdviceTopTriggerHeader';
import { HealthAdviceIcon } from './healthAdviceIcon';
import { HealthAdviceTopTriggerItemLoadingUI } from './loadingUI/healthAdviceTopTriggerItemLoadingUI';
import { aqiNoDataErrorStatusCode } from '../constants';
import { DefaultAqiErrorUI } from './noDataUI/defaultAqiErrorUI';
import { NoAqiDataUI } from './noDataUI/noAqiDataUI';
import { TopTriggersHealthAdviceContainer } from './styles';
import { AqiHealthAdviceAndTopTriggersType, HealthAdviceTypes } from './types';

export const healthAdvices = [
    'general',
    'lungAndHeartDisease',
    'children',
    'active'
] as const;

interface HealthAdviceProps {
    recommendations: AirQualityRecommendations;
    currentAirQualityIsFetching: boolean;
    isNoDataError: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { airQuality } = storeState ?? {};
    const { currentAirQuality, currentAirQualityIsFetching, lastError } = airQuality ?? {};
    const { recommendations } = currentAirQuality ?? {};
    const isNoDataError = lastError?.responseStatus === aqiNoDataErrorStatusCode;

    return {
        recommendations,
        currentAirQualityIsFetching,
        isNoDataError
    };
};

const mapDispatchToProps = {};

export const HealthAdvice = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ recommendations, currentAirQualityIsFetching, isNoDataError }: HealthAdviceProps) => {
    
    const renderList = useCallback((airQualityRecommendations: AirQualityRecommendations, isLoading: boolean, noDataError: boolean) => {
        if (isLoading) {
            const loadingList = numberOfAqiListItemsLoading(4);
            return (
                loadingList.map((loadingItemNumber: number, index: number) => {
                    return (
                        <HealthAdviceTopTriggerItemLoadingUI key={loadingItemNumber} showDivider={index !== (loadingList.length - 1)} />
                    );
                })
            );
        } else if (airQualityRecommendations) {
            return (
                healthAdvices.map((healthAdvice: string, index: number) => {
                    const healthAdviceTitle = airQualityRecommendations?.[healthAdvice as keyof AirQualityRecommendations]
                        ? translate(healthAdvice)
                        : '';

                    return (
                        <AirQualityListItem
                            healthAdviceType={healthAdvice}
                            key={`${healthAdvice}-${index}`} 
                            itemIcon={<HealthAdviceIcon healthAdviceName={healthAdvice as keyof typeof HealthAdviceTypes} />}
                            itemTitle={healthAdviceTitle}
                            showDivider={true}
                        />
                    );
                })   
            );
        } else if (noDataError) {
            return <NoAqiDataUI isHealthAdvice={true} />;
        } else {
            return <DefaultAqiErrorUI isHealthAdvice={true} />;
        }
    }, []);

    return (
        <TopTriggersHealthAdviceContainer isHealthAdvice={true}>
            <AqiHealthAdvicesTopTriggerHeader title={AqiHealthAdviceAndTopTriggersType.healthAdvice} />
            {
                renderList(recommendations, currentAirQualityIsFetching, isNoDataError)
            }
        </TopTriggersHealthAdviceContainer>
    );
}));
